export const DeliveryAndNotificationInformationFieldNames = {
  PrimaryDeliveryType: 'primaryDeliveryType',
  SecondaryDeliveryType: 'secondaryDeliveryType',
  DriverDelivery: 'driverDelivery',
  DriverDeliveryType: 'driverDeliveryType',
  DriverDeliveryName: 'driverDeliveryName',
  DriverDeliverySmsAuthorization: 'driverDeliverySmsAuthorization',
  DriverDeliveryCommunicationFrequency: 'driverDeliveryCommunicationFrequency',
  NotificationEmailAddress: 'notificationEmailAddress',
  NotificationMobilePhone: 'notificationMobilePhone',
  PrimaryDeliveryTypeValue: 'primaryDeliveryTypeValue',
  SecondaryDeliveryTypeValue: 'secondaryDeliveryTypeValue',
  PermitContactName: 'permitContactName',
  PermitContactPhone: 'permitContactPhone',
  PermitContactEmailAddress: 'permitContactEmailAddress',
} as const;

export type DeliveryAndNotificationInformationFields = {
  [DeliveryAndNotificationInformationFieldNames.PrimaryDeliveryType]?: string;
  [DeliveryAndNotificationInformationFieldNames.SecondaryDeliveryType]?: string;
  [DeliveryAndNotificationInformationFieldNames.NotificationEmailAddress]?: string;
  [DeliveryAndNotificationInformationFieldNames.NotificationMobilePhone]?: string;
  [DeliveryAndNotificationInformationFieldNames.PrimaryDeliveryTypeValue]?: string;
  [DeliveryAndNotificationInformationFieldNames.SecondaryDeliveryTypeValue]?: string;
  [DeliveryAndNotificationInformationFieldNames.PermitContactName]?: string;
  [DeliveryAndNotificationInformationFieldNames.PermitContactPhone]?: string;
  [DeliveryAndNotificationInformationFieldNames.PermitContactEmailAddress]?: string;
  [DeliveryAndNotificationInformationFieldNames.DriverDelivery]?: string;
  [DeliveryAndNotificationInformationFieldNames.DriverDeliveryType]?: string;
  [DeliveryAndNotificationInformationFieldNames.DriverDeliveryName]?: string;
  [DeliveryAndNotificationInformationFieldNames.DriverDeliverySmsAuthorization]?: boolean;
  [DeliveryAndNotificationInformationFieldNames.DriverDeliveryCommunicationFrequency]?: string;
};

export const alwaysShownPermitDeliveryFieldNames: readonly string[] = [
  DeliveryAndNotificationInformationFieldNames.PrimaryDeliveryType,
  DeliveryAndNotificationInformationFieldNames.PrimaryDeliveryTypeValue,
  DeliveryAndNotificationInformationFieldNames.SecondaryDeliveryType,
  DeliveryAndNotificationInformationFieldNames.SecondaryDeliveryTypeValue,
  DeliveryAndNotificationInformationFieldNames.DriverDelivery,
  DeliveryAndNotificationInformationFieldNames.DriverDeliveryType,
  DeliveryAndNotificationInformationFieldNames.DriverDeliveryName,
  DeliveryAndNotificationInformationFieldNames.DriverDeliverySmsAuthorization,
  DeliveryAndNotificationInformationFieldNames.DriverDeliveryCommunicationFrequency,
];
